import { apiGet, apiBasic } from "./requests";
export const listParkedCarts = (page) => apiGet("parked-carts", { page });
export const readParkCurrent = (shoppingCartId, customerId) =>
  apiGet(`parked-carts/current/${encodeURIComponent(shoppingCartId)}`, {
    customerId,
  });
export const parkCart = (body) => apiBasic(body, "parked-carts");
export const recoverPark = (id, body) =>
  apiBasic(body, `parked-carts/${encodeURIComponent(id)}/recover`);
export const discardPark = (id, body) =>
  apiBasic(body, `parked-carts/${encodeURIComponent(id)}/discard`);
